import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class EmbeddedTypeGroupBoxViewModel extends ControlViewModel {
    /**
     * Der Kontext des ViewModels
     */
    public context: any;

    /**
     * Definiert den Namen des inneren Layouts
     */
    public layout: string;

    /**
     * Enthält die inneren Children
     */
    public children: Array<any>;

    /**
     * Der Titel der GroupBox
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für die EmbeddedTypeGroupBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.context = this.paramOrDefault(params.context, null);
        this.layout = this.paramOrDefault(params.layout, 'EmbeddedGroupLayout');
        this.children = this.paramOrDefault(params.children, []);
        this.label = this.paramOrDefault(params.label);
    }
}

ComponentManager.setViewModel('EmbeddedTypeGroupBoxViewModel', EmbeddedTypeGroupBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');